import type {SocialAccount} from '@Components/social-media/account.vo';

export interface TiktokPublishingOptionsProps {
  account: SocialAccount;
}

export interface ContentDisclosureOption {
  title: string;
  description: string;
  isChecked: boolean;
  onToggle: VoidFunction;
}

export interface TikTokAccountMetaUpdateResponse {
  account: SocialAccount;
}

export const TIKTOK_ALLOW_USERS_OPTION_SKELETON_WIDTH = 84;
export const TIKTOK_ALLOW_USERS_OPTION_SKELETON_HEIGHT = 20;
export const TIKTOK_DISCLOSURE_TOGGLE_SKELETON_WIDTH = 42;
export const TIKTOK_DISCLOSURE_TOGGLE_SKELETON_HEIGHT = 24;
export const TIKTOK_ALLOW_USERS_OPTION_SKELETON_CORNER_RADIUS = '4px';
export const TIKTOK_TOGGLE_SKELETON_CORNER_RADIUS = '99px';
